module.exports = __webpack_public_path__ + "img/calendar2-x-fill.da08e220.svg";